import React from 'react';

const TopBar = () => {
  return (
    <div className="w-full bg-green-50 py-3">
      <div className="max-w-4xl mx-auto px-4">
        <img
          src="/images/topbar-banner.jpg"
          alt="Topbar Banner"
          className="w-full h-auto object-cover rounded-lg block"
        />
      </div>
    </div>
  );
};

export default TopBar;
